/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationIPWhitelist
 */
export interface OrganizationIPWhitelist {
    /**
     * The ID of the organization
     */
    organization_id: string;
    /**
     * The whitelisted IP address or CIDR notation
     */
    ip_address: string;
    /**
     * Optional description for the IP address
     */
    description?: string;
    /**
     * ID of the user who added this IP address
     */
    created_by?: string;
    /**
     * Timestamp when the IP address was added to the whitelist
     */
    created_at: Date;
    /**
     * Timestamp when the IP address was last updated
     */
    updated_at?: Date;
}

/**
 * Check if a given object implements the OrganizationIPWhitelist interface.
 */
export function instanceOfOrganizationIPWhitelist(value: object): value is OrganizationIPWhitelist {
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('ip_address' in value) || value['ip_address'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    return true;
}

export function OrganizationIPWhitelistFromJSON(json: any): OrganizationIPWhitelist {
    return OrganizationIPWhitelistFromJSONTyped(json, false);
}

export function OrganizationIPWhitelistFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationIPWhitelist {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'],
        'ip_address': json['ip_address'],
        'description': json['description'] == null ? undefined : json['description'],
        'created_by': json['created_by'] == null ? undefined : json['created_by'],
        'created_at': (json['created_at'] == null ? json['created_at'] : parseDateTime(json['created_at'])),
        'updated_at': json['updated_at'] == null ? undefined : (parseDateTime(json['updated_at'])),
    };
}

export function OrganizationIPWhitelistToJSON(json: any): OrganizationIPWhitelist {
    return OrganizationIPWhitelistToJSONTyped(json, false);
}

export function OrganizationIPWhitelistToJSONTyped(value?: OrganizationIPWhitelist | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'ip_address': value['ip_address'],
        'description': value['description'],
        'created_by': value['created_by'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
    };
}

